import SCard from "./SCard";
import { useReadContracts } from "wagmi";
import { useMemo } from "react";
import { BigNumber } from "ethers";
import { LSTIconMapping, formatEtherNumber } from "@constants/common";
import { getImageWithSubRoute, numberToCurrency } from "utils";
import { Avatar, Flex, Text } from "@chakra-ui/react";
// import { AiOutlineInfoCircle } from "react-icons/ai";
import useDappConfig from "@hooks/useDappConfig";

const functionNames = ["getTotalAssetDeposits", "getAssetDistributionData"];

const AssetsRestakedCard = () => {
  const { config } = useDappConfig();
  const tokens = config.tokens;

  const tokenContractCalls = Object.keys(tokens).map((key) => {
    return functionNames.map((functionName) => ({
      ...config.interactionPools.lrtDepositPool,
      functionName,
      args: [tokens[key].address],
    }));
  });

  const nativeTokenCalls = functionNames.map((functionName) => ({
    ...config.interactionPools.lrtDepositPool,
    functionName,
    args: [config.nativeToken.address],
  }));

  const contractCalls = [...tokenContractCalls.flat(), ...nativeTokenCalls];

  const { data } = useReadContracts({
    contracts: contractCalls,
  });

  const assetsStakedStats = useMemo(() => {
    if (!data) return;

    type BN = BigNumber;

    const formatCur = (value: BN | null) => {
      return value
        ? numberToCurrency(formatEtherNumber(value.toString(), 2).toString())
        : "-";
    };

    const getAssetDistribution = (assetDistribution: [BN, BN, BN] | null) => {
      if (!assetDistribution || !assetDistribution.length) return;

      const [
        assetLyingInDepositPool,
        assetLyingInNDCs,
        assetStakedInEigenLayer,
      ] = assetDistribution.map((d) => BigNumber.from(d));

      const received = assetLyingInDepositPool
        .add(assetLyingInNDCs)
        .add(assetStakedInEigenLayer);

      const toBeStaked = assetLyingInDepositPool.add(assetLyingInNDCs);

      return {
        received: formatEtherNumber(received.toString(), 2).toLocaleString(),
        toBeStaked: formatEtherNumber(
          toBeStaked.toString(),
          2
        ).toLocaleString(),
        stakedInEigenLayer: formatEtherNumber(
          assetStakedInEigenLayer.toString(),
          2
        ).toLocaleString(),
      };
    };

    const filteredResponse = data.map((d) => d.result!);
    return [...Object.keys(tokens), config.nativeToken.symbol].map(
      (key, index) => {
        const assetsDepositIndex = index * 2;
        const distributionDetailsIndex = assetsDepositIndex + 1;
        return {
          title: key,
          value: formatCur(filteredResponse[assetsDepositIndex] as BN),
          icon: getImageWithSubRoute(LSTIconMapping[key]),
          assetDistribution: getAssetDistribution(
            filteredResponse[distributionDetailsIndex] as [BN, BN, BN]
          ),
        };
      }
    );
  }, [config.nativeToken.symbol, data, tokens]);

  return (
    <SCard title="Assets Restaked">
      <Flex flexWrap="wrap" gap={4}>
        {assetsStakedStats?.map((asset) => {
          return (
            asset.title != "sfrxETH" && (
              <Flex
                key={asset.title}
                direction={{
                  base: "row-reverse",
                  xl: "column",
                }}
                w={{
                  base: "100%",
                  xl: "45%",
                }}
                gap={1}
                justifyContent="space-between"
              >
                <Flex alignItems="center" gap={2}>
                  <Text fontWeight={700} fontSize={14}>
                    {asset.value}
                  </Text>
                  {/* {asset.assetDistribution && (
                    <Popover trigger="hover" placement="top">
                      <PopoverTrigger>
                        <Box cursor="pointer">
                          <AiOutlineInfoCircle />
                        </Box>
                      </PopoverTrigger>
                      <PopoverContent w={160}>
                        <PopoverArrow />
                        <PopoverBody>
                          <Flex direction="column" gap={4}>
                            <Box>
                              <Text fontSize={10}>Deposited on Kelp</Text>
                              <Text>{asset.assetDistribution.received}</Text>
                            </Box>
                            <Box>
                              <Text fontSize={10}>Restaked on EigenLayer</Text>
                              <Text>
                                {asset.assetDistribution.stakedInEigenLayer}
                              </Text>
                            </Box>
                            <Box>
                              <Text fontSize={10}>To be Restaked</Text>
                              <Text>{asset.assetDistribution.toBeStaked}</Text>
                            </Box>
                          </Flex>
                        </PopoverBody>
                      </PopoverContent>
                    </Popover>
                  )} */}
                </Flex>
                <Flex gap={1}>
                  <Avatar w={4} h={4} src={asset.icon} />
                  <Text>{asset.title}</Text>
                </Flex>
              </Flex>
            )
          );
        })}
      </Flex>
    </SCard>
  );
};

export default AssetsRestakedCard;
